import React from 'react'
import Title from '../../../../system/title/Title'
import { Container, PhoneNumberArea } from './Styled'
import {
  toDate,
  toHour,
  timespanToString,
} from '../../../../../helpers/dateFormatHelper'
import { Tag } from 'antd'
type ItemProps = {
  phoneNumber: string
  date: string
  duration: string
}

const Item: React.FunctionComponent<ItemProps> = ({
  date,
  duration,
  phoneNumber,
}) => {
  return (
    <Container>
      <PhoneNumberArea>
        <Tag color="blue">{phoneNumber}</Tag>
        <Tag color="magenta">{timespanToString(duration)}</Tag>
      </PhoneNumberArea>
      <Title title={toHour(date)} titleSize="small" subTitle={toDate(date)} />
    </Container>
  )
}

export default Item
